import { useState, useEffect } from "react";
import { companyInfo } from "../data/mock";
import { Button } from "./ui/button";
import { Phone, Menu, X } from "lucide-react";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Calculator", href: "#tonnage-calculator" },
    { label: "Why Us", href: "#why-us" },
    { label: "Process", href: "#process" },
    { label: "FAQ", href: "#faq" },
  ];

  const scrollToSection = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm border-b border-slate-100"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img
              src={companyInfo.logos.main}
              alt="Fix My AC - India's Premier HVAC Solutions Provider"
              className="h-14 lg:h-16 w-auto object-contain transition-all duration-300"
              width="160"
              height="64"
            />
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollToSection(link.href)}
                className={`px-3.5 py-2 rounded-lg text-sm font-medium transition-all duration-200 hover:bg-white/10 ${
                  scrolled
                    ? "text-slate-600 hover:text-brand-600 hover:bg-brand-50"
                    : "text-white/85 hover:text-white"
                }`}
              >
                {link.label}
              </button>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <a href={`tel:${companyInfo.phone}`} className={`flex items-center gap-1.5 text-sm font-medium transition-colors ${
              scrolled ? "text-slate-600 hover:text-brand-600" : "text-white/85 hover:text-white"
            }`}>
              <Phone className="w-4 h-4" />
              <span>{companyInfo.phone}</span>
            </a>
            <Button
              onClick={() => scrollToSection("#cta")}
              className="bg-accent-500 hover:bg-accent-600 text-white text-sm px-5 h-9 rounded-lg shadow-sm transition-all duration-200"
            >
              Get a Quote
            </Button>
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors ${
              scrolled ? "text-slate-700 hover:bg-slate-100" : "text-white hover:bg-white/10"
            }`}
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden overflow-hidden transition-all duration-300 ${
        mobileOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
      }`}>
        <div className="bg-white border-t border-slate-100 shadow-lg px-4 py-4 space-y-1">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => scrollToSection(link.href)}
              className="block w-full text-left px-4 py-2.5 text-sm font-medium text-slate-700 hover:text-brand-600 hover:bg-brand-50 rounded-lg transition-colors"
            >
              {link.label}
            </button>
          ))}
          <div className="pt-3 border-t border-slate-100 flex flex-col gap-2">
            <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2 px-4 py-2 text-sm text-slate-600">
              <Phone className="w-4 h-4" /> {companyInfo.phone}
            </a>
            <Button
              onClick={() => scrollToSection("#cta")}
              className="bg-accent-500 hover:bg-accent-600 text-white w-full rounded-lg"
            >
              Get a Quote
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
